import { MockKanban } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/**
 * View 1 — `template.html:871`. Bảng kanban 5 cột.
 *
 * Đây là HỘ DÙNG THỨ HAI của `MockKanban` (hộ đầu là pane kanban của hero). Nếu chỗ này cần một
 * prop mà component không có thì DỪNG: sửa `packages/ui` ở đây nghĩa là lô B–F đang dựa trên một
 * thứ khác (plan lô A′ §0.2). Chốt API bằng cả hai hộ dùng chính là lý do lô A gộp với lô B.
 *
 * Hai chỉ số ĐO từ thiết kế: card đang làm là card đầu của cột "đang làm" (cột 2, dòng 874 — có
 * viền `brand-200` + bóng), cột cuối là cột đã hoàn tất (dòng 876 — chữ mờ, gạch ngang).
 */
const IN_PROGRESS_COLUMN = 2;
const DONE_COLUMN = 4;

export function KanbanView() {
  const kanban = useCopy().pm.kanban;

  return (
    <MockKanban
      density="section"
      columns={kanban.columns.map((column, columnIndex) => ({
        title: column.title,
        cards: column.cards.map((text, cardIndex) => ({
          text,
          active: columnIndex === IN_PROGRESS_COLUMN && cardIndex === 0,
          done: columnIndex === DONE_COLUMN,
        })),
      }))}
    />
  );
}
